import { useSelector } from 'react-redux';

import { selectIsPrestoOwner } from 'state/selectors';

export const useIsPrestoOwner = () => useSelector(selectIsPrestoOwner);
